module.exports = __webpack_public_path__ + "media/images/pic/home/video-course-preview-8adb5a7c92581890d9ae03e8de4dc94b.png";